
 /**
    1-9 万
    11-19 条
    21-29 筒
    
    31-37 东南西北中发白
*/

import data_control from "../../../../../../engines/libs/data_control";
import { MingTangKind } from "./MingTangKind";

/** 牌型数据区间 */
const CardTypeArea = [
    [1, 9],
    [11,19],
    [21,29],
    [31, 37],
]

export class MingTangDataManage {
    
    /**
     * 根据牌型生成牌数据
     * @param type 
     * @returns 
     */
    static generateCardType(type: number): MingTangKind.CardTypeData {
        let TYPE = MingTangKind.CardType;
        switch(type) {
            case TYPE.DA_SI_XI: {
                return this.generateDaSiXi();
            }
            case TYPE.LIU_LIU_SHUN: {
                return this.generateLiuLiuShun();
            }
            case TYPE.XIAO_QING_LONG: {
                return this.generateXiaoQingLong();
            }
            case TYPE.TIAN_XIA_WU_SHUANG: {
                return this.generateTianXiaWuShuang();
            }
            case TYPE.JIU_LIAN_BAO_DENG: {
                return this.generateJiuLianBaoDeng();
            }
        }
    }

    /**
     * 获得牌数据
     * @param count 
     * @param sameNum 
     * @param ownCardData 
     * @returns 
     */
    static getSameCardData(
        count: number
        , sameNum: number
        , ownCardData: number[]
        , areaData: number[][] = null
    ) {
        let cardData: number[] = [];
        for (let i = 0; i < count; i++) {
            while(true) {
                let randomV = this.getRandomCard(areaData);
                if (!ownCardData.includes(randomV)) {
                    for (let j = 0; j < sameNum; j++) {
                        ownCardData.push(randomV);
                    }
                    cardData.push(randomV);
                    break;
                }
            }
        }
        return cardData;
    }

    /**
     * 获得随机牌
     * @returns 
     */
    static getRandomCard(
        areaData: number[][] = null
    ) {
        if (!areaData) {
            areaData = CardTypeArea;
        }
        let len = areaData.length;
        let random = data_control.randomNumInt(0, len-1);
        let cardArea = areaData[random];
        let value = data_control.randomNumInt(cardArea[0], cardArea[1]);
        return value;         
    }

    /** 大四喜 */
    static generateDaSiXi(): MingTangKind.CardTypeData {
        let cardTypeData = new MingTangKind.CardTypeData();
        
        let card = 36;
        cardTypeData.card.push(card, card, card, card);
        cardTypeData.winCard.push(card);
        return cardTypeData;
    }

    /** 六六顺 */
    static generateLiuLiuShun(): MingTangKind.CardTypeData {
        let cardTypeData = new MingTangKind.CardTypeData();
        const cardAdd = 5;
        let randomArr = data_control.randomIntNum(0, CardTypeArea.length-2, 2);

        for (let o of randomArr) {
            let cardArea = CardTypeArea[o];
            let card = cardArea[0] + cardAdd;
            cardTypeData.card.push(card, card, card);
            cardTypeData.winCard.push(card);
        }
        return cardTypeData;
    }

    /** 小青龙 */
    static generateXiaoQingLong(): MingTangKind.CardTypeData {
        let cardTypeData = new MingTangKind.CardTypeData();

        const count = 5;
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardAreaTmp = CardTypeArea[randomIdx];
        let max = cardAreaTmp[1]-count+1;
        let startIdx = data_control.randomNumInt(cardAreaTmp[0], max);
        for (let i = 0; i < count; i++) {
            let card = startIdx+i;
            cardTypeData.card.push(card);
            cardTypeData.winCard.push(card);
        }
        return cardTypeData;
    }

    /** 天下无双 */
    static generateTianXiaWuShuang(): MingTangKind.CardTypeData {
        let cardTypeData = new MingTangKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardAreaTmp = CardTypeArea[randomIdx];
        const cardAdd = [0, 2, 4, 6, 8];
        for (let o of cardAdd)  {
            let card = cardAreaTmp[0] + o;
            cardTypeData.card.push(card);
            cardTypeData.winCard.push(card);
        }
        return cardTypeData;
    }

    /** 九连宝灯 */
    static generateJiuLianBaoDeng(): MingTangKind.CardTypeData {
        let cardTypeData = new MingTangKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardAreaTmp = CardTypeArea[randomIdx];
        for (let o of cardAreaTmp) {
            cardTypeData.card.push(o, o, o);
        }
        
        for (let i = cardAreaTmp[0]+1; i < cardAreaTmp[1]; i++) {
            cardTypeData.card.push(i);
        }
        
        for (let i = cardAreaTmp[0]; i <= cardAreaTmp[1]; i++) {
            cardTypeData.winCard.push(i);
        }
        return cardTypeData;
    }

    
}